import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Cookies from './pages/Cookies';
import Imprint from './pages/Imprint';
import EmployeePortal from './pages/EmployeePortal';
import PartnerPortal from './pages/PartnerPortal';
import AuthCallback from './pages/AuthCallback';
import ResetPassword from './pages/ResetPassword';
import AdminPage from './pages/AdminPage';
import Overview from './pages/Overview';
import PlatformPillarPage from './pages/PlatformPillarPage';
import About from './pages/About';
import Careers from './pages/Careers';
import ServiceStagePage from './pages/ServiceStagePage';
import SolutionCategoryPage from './pages/SolutionCategoryPage';
import IndustryPage from './pages/IndustryPage';
import Insights from './pages/Insights';
import Blog from './pages/Blog';
import Events from './pages/Events';
import Docs from './pages/Docs';
import { STAGE_ORDER } from './data/serviceStages';
import { SOLUTION_ORDER } from './data/solutionCategories';
import { INDUSTRY_ORDER } from './data/industries';
import { LeadDialogProvider } from './context/LeadDialogContext';
import { AuthProvider } from './context/AuthContext';
import { SignInDialogProvider } from './context/SignInDialogContext';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import ChatWidget from './components/ChatWidget';
import { Toaster } from './components/ui/toaster';

// Intercepts OAuth callback (session_id in URL hash) before any other route renders.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/cookies" element={<Cookies />} />
      <Route path="/imprint" element={<Imprint />} />
      <Route
        path="/partner-portal"
        element={
          <ProtectedRoute role="partner">
            <PartnerPortal />
          </ProtectedRoute>
        }
      />
      <Route
        path="/employee-portal"
        element={
          <ProtectedRoute role="employee">
            <EmployeePortal />
          </ProtectedRoute>
        }
      />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/platform" element={<Overview />} />
      <Route path="/platform/observability" element={<PlatformPillarPage slug="observability" />} />
      <Route path="/platform/self-healing" element={<PlatformPillarPage slug="self-healing" />} />
      <Route path="/platform/ai-agents" element={<PlatformPillarPage slug="ai-agents" />} />
      <Route path="/about" element={<About />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/insights" element={<Insights />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/events" element={<Events />} />
      <Route path="/docs" element={<Docs />} />
      {STAGE_ORDER.map((slug) => (
        <Route key={slug} path={`/services/${slug}`} element={<ServiceStagePage slug={slug} />} />
      ))}
      {SOLUTION_ORDER.map((slug) => (
        <Route key={slug} path={`/solutions/${slug}`} element={<SolutionCategoryPage slug={slug} />} />
      ))}
      {INDUSTRY_ORDER.map((slug) => (
        <Route key={slug} path={`/industries/${slug}`} element={<IndustryPage slug={slug} />} />
      ))}
      <Route path="*" element={<Home />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SignInDialogProvider>
            <LeadDialogProvider>
              <ScrollToTop />
              <AppRouter />
              <ChatWidget />
              <Toaster />
            </LeadDialogProvider>
          </SignInDialogProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
